module.exports = __webpack_public_path__ + "static/media/previewNormingUpper.c7c5f9dd.mp4";